export const RouterName = {
    ya50Wish: 'ya50Wish',
};

// url 地址上的 查询参数名称
export const RouterQuery = {
    auth: 'auth',
    orderID: 'orderID',
};

// 微信的登录类型  snsapi_base和snsapi_userinfo 权限
export const WxLoginType = {
    base: 'snsapi_base',
    userinfo: 'snsapi_userinfo',
};

// 本地存储的key
export const LocKey = {
    auth: 'auth',
    orderInfo: 'orderInfo',
    maintenanceCardDetails: 'maintenanceCardDetails',
};

// 微信的查询参数数组
export const WxQkeyArr = ['code', 'state'];

// 微信sdk 要使用的方法
export const WxInitSDKUseFunNameArr = [
    // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
    'updateAppMessageShareData',
    // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
    'updateTimelineShareData',
];

export const RouterNameObj = {
    // 50的营销页面
    ya50Wish: 'ya50Wish',
    ya50WishOrder: 'ya50WishOrder',
    ya50WishOrderList: 'ya50WishOrderList',
    ya50WishOrderDetails: 'ya50WishOrderDetails',
    // 售后
    maintenance: 'maintenance',
    // 创建保修卡
    maintenanceCreate: 'maintenanceCreate',
    // 保修卡登录
    maintenanceLogin: 'maintenanceLogin',
    // 保修卡详情
    maintenanceCardDetails: 'maintenanceCardDetails',
};

export const VvflyPath = '/vvflyPath';
